import { NgModule } from '@angular/core';
import { WhiteSpace } from './white-space.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [WhiteSpace],
  exports: [WhiteSpace],
  imports: [CommonModule]
})
export class WhiteSpaceModule {}
